// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Components.Toasts.LinkToast = createReactClass({
    propTypes: {
      text: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
      linkAction: PropTypes.func.isRequired,
    },

    render: function(){
      return (
        <div className="u-fs14 u-tcWhite u-fw700 u-taCenter">
          {this.props.text}&nbsp;&nbsp;&nbsp;
          <a
            href="#"
            className="u-textDecorationNone"
            style={{color:'#AABECE'}}
            onClick={this.props.linkAction}
          >
            {this.props.linkText}
          </a>
        </div>
      );
    },

  });
})();
